import { alpha, Backdrop, Badge, Box, ClickAwayListener, makeStyles, Tooltip } from "@material-ui/core";
import { NotificationsActiveTwoTone } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import useDevice from "src/hooks/use-device";
import useFetchNotify from "src/hooks/use-fetch-notify";
import { setOpenNotify } from "src/redux/account-slice";
import NotifyItem from "./NotifyItem";

const useStyles = makeStyles((theme) => ({
  tooltip: (props) => ({
    cursor: "pointer",
    marginRight: props.maximumUI ? "2px" : "8px",
    zIndex: 2,
    "& .MuiTooltip-popper": {
      pointerEvents: "initial",
      top: "20px !important",
      "& .MuiTooltip-tooltip": {
        padding: "0px 0px 0px",
        maxWidth: "unset",
        backgroundColor: "#001328",
        "& .MuiTooltip-arrow": {
          color: "#001328",
          top: "-13px",
          height: "20px",
          width: "30px",
        },
      },
    },
  }),
  item: {
    width: "310px",
    background: "#001328",
    maxHeight: "500px",
    borderRadius: "8px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: 2,
    },
    "&::-webkit-scrollbar:horizontal": {
      height: 2,
    },
    "&::-webkit-scrollbar-thumb, &::-webkit-scrollbar-corner": {
      backgroundColor: alpha(theme.palette.common.white, 0.65),
    },
  },
  noNotifyWp: {
    textAlign: "center",
    fontWeight: 400,
    fontSize: "18px",
    cursor: "pointer",
  },
  svg: {
    opacity: "65%",
    fontSize: "22px",
    marginTop: "2px",
  },
}));

export default function Notification() {
  const dispatch = useDispatch();
  const openNotify = useSelector((state) => state.accountSlice.openNotify);
  const { width } = useDevice();
  const maximumUI = width > 1285;
  const cls = useStyles({ maximumUI });
  const listNotify = useSelector((state) => state.accountSlice.listNotification);
  useFetchNotify();

  const handleOpenNotify = (open) => {
    if ((openNotify && !open) || (!openNotify && open)) {
      dispatch(setOpenNotify(open));
    }
  };

  return (
    <>
      <ClickAwayListener onClickAway={() => handleOpenNotify(false)}>
        <div className={cls.tooltip}>
          <Tooltip
            arrow
            placement={maximumUI ? "top" : "top-end"}
            title={
              <Box className={cls.item}>
                {listNotify.length ? (
                  listNotify.map((i, idx) => (
                    <NotifyItem index={idx} key={idx} item={i} isLastRecord={idx == listNotify.length - 1} />
                  ))
                ) : (
                  <Box my={6} className={cls.noNotifyWp} onClick={() => handleOpenNotify(false)}>
                    No new report!
                  </Box>
                )}
              </Box>
            }
            PopperProps={{ disablePortal: true }}
            open={openNotify}
            disableFocusListener
            disableTouchListener
          >
            <Badge
              onClick={() => handleOpenNotify(true)}
              style={{ margin: "4px" }}
              overlap="rectangle"
              badgeContent={listNotify.length}
              color="primary"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <NotificationsActiveTwoTone className={cls.svg} />
            </Badge>
          </Tooltip>
        </div>
      </ClickAwayListener>
      <Backdrop style={{ zIndex: 1 }} open={openNotify} onClick={() => handleOpenNotify(false)} />
    </>
  );
}
